module.exports = __webpack_public_path__ + "static/media/delete.8229557a.svg";